import styled from "styled-components";

import { FaSearch } from "react-icons/fa";

export const CountriesGridLayout = styled.div.attrs({
  className: "grid gap-5 md:grid-cols-2 xl:grid-cols-4",
})``;

export const CountriesGridLayoutSecondary = styled.div.attrs({
  className: "mt-8 grid gap-6 xl:grid-cols-[1.15fr_0.85fr]",
})``;

export const CountriesFormStack = styled.form.attrs({ className: "space-y-4" })``;

export const CountriesFieldShell = styled.div.attrs({ className: "relative" })``;

export const CountriesSearchIcon = styled(FaSearch).attrs({
  className:
    "pointer-events-none absolute left-4 top-1/2 -translate-y-1/2 text-[var(--brand-muted)]",
})``;

export const CountriesSearchInput = styled.input.attrs({ className: "brand-input pl-11" })``;

export const CountriesHeaderRow = styled.div.attrs({
  className: "flex flex-wrap items-center justify-between gap-2 text-xs text-[var(--brand-muted)]",
})``;

export const CountriesScrollArea = styled.div.attrs({
  className: "max-h-[24rem] space-y-2 overflow-y-auto pr-1",
})``;

export const CountriesInfoRow = styled.div.attrs({
  className: "flex min-w-0 items-center gap-3",
})``;

export const CountriesTextGroup = styled.div.attrs({ className: "min-w-0" })``;

export const CountriesLabelText = styled.p.attrs({
  className: "truncate font-medium text-[var(--brand-ink)]",
})``;

export const CountriesMetaText = styled.p.attrs({
  className: "text-xs text-[var(--brand-muted)]",
})``;

export const CountriesPrimaryButton = styled.button.attrs({
  className: "brand-button inline-flex items-center gap-2",
})``;

export const CountriesEmptyStatePanel = styled.div.attrs({
  className:
    "mt-6 rounded-3xl border border-dashed border-[var(--brand-border)] bg-[var(--brand-bg)]/45 px-5 py-5",
})``;

export const CountriesEyebrowText = styled.p.attrs({
  className: "text-xs uppercase tracking-[0.2em] text-[var(--brand-muted)]",
})``;

export const CountriesInfoRowSecondary = styled.div.attrs({
  className: "mt-3 flex items-center gap-3",
})``;

export const CountriesIconBadge = styled.span.attrs({
  className:
    "flex h-11 w-11 items-center justify-center rounded-2xl bg-[var(--brand-highlight)]/12 text-[var(--brand-highlight)]",
})``;

export const CountriesTitleText = styled.p.attrs({
  className: "text-xl font-semibold text-[var(--brand-ink)]",
})``;

export const CountriesMetaTextSecondary = styled.p.attrs({
  className: "mt-1 text-sm text-[var(--brand-muted)]",
})``;

export const CountriesBodyText = styled.p.attrs({
  className: "mt-2 text-sm leading-6 text-[var(--brand-muted)]",
})``;

export const CountriesSection = styled.div.attrs({ className: "mt-8" })``;

export const CountriesLabelTextSecondary = styled.p.attrs({
  className: "font-medium text-[var(--brand-ink)]",
})``;

export const CountriesFieldInput = styled.input.attrs({ className: "brand-input" })``;

export const CountriesActionRow = styled.div.attrs({ className: "flex justify-end gap-3" })``;

export const CountriesSecondaryButton = styled.button.attrs({
  className: "brand-button-secondary",
})``;

export const CountriesPrimaryButtonSecondary = styled.button.attrs({ className: "brand-button" })``;

export const CountriesContentStack = styled.div.attrs({ className: "space-y-3" })``;

export const CountriesFieldLabel = styled.label.attrs({
  className: "text-sm text-[var(--brand-muted)]",
})``;

export const CountriesOptionButton = styled.button.attrs<{
  $alreadySelected: boolean;
  $isActive: boolean;
}>(({ $alreadySelected, $isActive }) => ({
  className: [
    "flex w-full items-center justify-between rounded-2xl border px-4 py-3 text-left transition",
    $isActive
      ? "border-[var(--brand-highlight)] bg-[var(--brand-highlight)]/12 shadow-sm"
      : $alreadySelected
      ? "border-emerald-200 bg-emerald-50/80"
      : "border-[var(--brand-border)] bg-[rgba(255,255,255,0.04)] hover:border-[var(--brand-highlight)]/60 hover:bg-[rgba(240,191,86,0.08)]",
  ].join(" "),
}))`` as any;

export const CountriesIconBadgeSecondary = styled.span.attrs<{
  $alreadySelected: boolean;
}>(({ $alreadySelected }) => ({
  className: [
    "flex h-10 w-10 shrink-0 items-center justify-center rounded-2xl",
    $alreadySelected
      ? "bg-emerald-100 text-emerald-700"
      : "bg-[var(--brand-highlight)]/12 text-[var(--brand-highlight)]",
  ].join(" "),
}))`` as any;

export const CountriesStatusBadge = styled.span.attrs<{
  $alreadySelected: boolean;
  $isActive: boolean;
}>(({ $alreadySelected, $isActive }) => ({
  className: [
    "ml-3 inline-flex shrink-0 items-center gap-1 rounded-full px-3 py-1 text-xs font-medium",
    $alreadySelected
      ? "bg-emerald-100 text-emerald-800"
      : $isActive
      ? "bg-[var(--brand-highlight)] text-white"
      : "bg-slate-100 text-slate-700",
  ].join(" "),
}))`` as any;

